<template>
  <div class="container">
    <div class="left"
         style="border-right: 1px solid #eda91b">
      <div>
        <vue-ueditor-wrap id="ueditor01"
                          v-model="tempContent"
                          :config="myArticl"></vue-ueditor-wrap>
      </div>
      <div class="btnClass">
        <el-upload v-show="ifAccountId"
                   class="upload-demo"
                   ref="upload"
                   accept=".doc,.docx"
                   :multiple="false"
                   :limit="1"
                   :file-list="fileList"
                   :data="uploadData"
                   :show-file-list="false"
                   :on-change="fileChange"
                   :before-upload="beforeUpload"
                   :on-success="uploadSuccess"
                   :action="uploadUrl">
          <el-button slot="trigger"
                     type="success"
                     plain
                     size="small">导入Word</el-button>
          <div slot="tip"
               class="el-upload__tip">只能上传doc/docx格式文件</div>
        </el-upload>
        <el-button @click="clearData"
                   type="danger"
                   size="small">清空内容</el-button>

        <el-button @click="checkArticl"
                   type="success"
                   size="small">文本校验</el-button>
      </div>
    </div>
    <div class="center">
      <div style="padding: 8px;width: auto;overflow: hidden;font-size: 24px;border-bottom: solid 1px red;color:red;">
        系统提示：审核结果仅为参考建议，非强制性要求，可酌情采用。若有异议，请联系技术人员。
      </div>
      <div style="width: 100%; height: calc(100vh - 80px); overflow-y: auto; overflow-x: hidden"
           :class="[ifImage == 1 ? 'addImg' : '']">
        <div style="font-size: 14px"
             class="card"
             v-for="item in tempListData"
             :key="item.startPos">
          <div style="width: 100%; height: 20%">
            <p style="
                float: left;
                margin-top: 12px;
                margin-left: 15px;
              "
               v-html="getColorTextByLevel(item.level,errorWord,true)">
            </p>
            <div :class="[currentRightSpan=='11'?'caozuo_AllDiv':'caozuo_changeDiv']">
              <a href="javascript:void(0)"
                 @click.stop
                 v-show="item.isDeal==0"
                 @click="replaceWord(item.startPos)"
                 class="caozuoTitle">
                替换
              </a>
              <a href="javascript:void(0)"
                 @click.stop
                 v-show="item.isDeal==0"
                 @click="ignoreWord(item.startPos)"
                 class="caozuoTitle">
                忽略
              </a>
              <a href="javascript:void(0)"
                 v-show="item.isDeal==1"
                 @click="revokeWord(item.startPos)"
                 class="caozuoTitle">
                撤销
              </a>
            </div>
          </div>
          <div style="width: 100%; height: 80%">
            <table id="keywordTb"
                   @click="addBgColor(item.startPos)">
              <tr>
                <td style="width:25%;">疑似错误：</td>
                <td v-html="getColorTextByLevel(item.level,item.sourceKeyWord)"> </td>
              </tr>
              <tr>
                <td>建议改正：</td>
                <td>{{ item.replaceKeyword }}</td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="right"
         style="z-index: 99999">
      <div :class="[currentRightSpan == item.id ? 'changeBk' : '']"
           @click="rightSpanClick(item.id)"
           :style="item.style"
           v-for="item in rightSpan"
           :key="item.id">
        <div class="top">
          {{ item.countNum }}
          <div class="circular"
               :style="{ 'background-color': item.circular }"></div>
        </div>
        <div class="body"
             :style="item.titleStyle">{{ item.title }}</div>
      </div>
    </div>
  </div>
</template>  
<script>

import { verifyText, verifyTextByTYQW, verifyTextByIJiaoDui } from "../api/index";
import { quillEditor } from "vue-quill-editor";
import VueUeditorWrap from "vue-ueditor-wrap";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { replaceAt, replaceSubstring } from "../utils/index";
import { Loading } from 'element-ui';

export default {
  components: {
    quillEditor,
    VueUeditorWrap,
  },
  data() {
    return {
      //页面是否有AccountId数据
      ifAccountId: false,
      uploadUrl: "http://bigdata_api.beikunit.com/api/file/upload",
      fileList: [],
      uploadData: {},
      //存储listdata数据的
      tempListData: [],
      //全部数据以及正确数据
      listData: [],
      //错误文段
      enderContent: '',
      //错误字词
      errorWord: "错误字、词",
      //无数据时，显示的图片
      ifImage: true,
      //用于渲染段落数据
      tempContent: "",

      //params提交数据的字符串
      params: {},
      currentTag: 10000,
      currentRightSpan: 11,
      myArticl: {
        toolbars: [
          [
            "undo",
            "redo",
            "|",
            "bold",
            "italic",
            "underline",
            "fontborder",
            "strikethrough",
            "removeformat",
            "formatmatch",
            "autotypeset",
            "|",
            "insertorderedlist",
            "insertunorderedlist",
            "selectall",
            "|",
            "rowspacingtop",
            "rowspacingbottom",
            "lineheight",
            "|",
            "customstyle",
            "paragraph",
            "fontfamily",
            "fontsize",
            "|",
            "directionalityltr",
            "directionalityrtl",
            "indent",
            "|",
            "justifyleft",
            "justifycenter",
            "justifyright",
            "justifyjustify",
            "|",
            "touppercase",
            "tolowercase",
            "|",
            "imagenone",
            "imageleft",
            "imageright",
            "imagecenter",
            "|",
            "horizontal",
            "date",
            "time",
          ],
        ],
        autoHeightEnabled: false, // 编辑器不自动被内容撑高
        initialFrameHeight: "90em", // 初始容器高度
        initialFrameWidth: "100%", // 初始容器宽度
        serverUrl: "",
        UEDITOR_HOME_URL: "/UEditor/",
        maximumWords: "100000000",
      },
      //最右侧卡片
      rightSpan: [
        {
          id: "11",
          title: "全部错误",
          style:
            "height: 120px;border-radius: 10px;margin-left: 8px;",
          circular: "transparent",
          titleStyle: "font-size: 15px",
          countNum: 0,
        },

        {
          id: "22",
          title: "修改记录",
          style:
            "height: 120px;border-radius: 10px;margin-top: 10px;margin-left: 8px;",
          circular: "#34c68c",
          titleStyle: "color: #34c68c;font-size: 15px",
          countNum: 0,
        },
      ],
    };
  },
  created() {
    window.screenHeight = document.body.clientHeight;
  },
  async mounted() {
    window.screenHeight = document.body.clientHeight;
    this.myArticl.initialFrameHeight = window.screenHeight - 180;
    var account_id = this.$route.query.account_id;
    this.ifAccountId = false;
    if (account_id != null && account_id != "" && account_id != undefined) {
      this.ifAccountId = true;
    }
  },
  watch: {
    tempListData(newValue) {
      this.ifImage = false;
      if (newValue.length == 0) {
        this.ifImage = true;
      }
    }
  },
  methods: {
    // 选择文件、移除文件、上传文件成功/失败后，都会触发
    fileChange(file, list) {
      // if (list.length > 1 && file.status !== "fail") {
      //   list.splice(0, 1);
      // } else if (file.status === "fail") {
      //   this.$message.error("上传失败,请重新上传");
      //   list.splice(0, 1);
      // }
    },
    // 文件上传前的校验 —— 常见的校验有：校验文件类型，文件大小
    beforeUpload(file) {
      // 允许上传的文件格式列表
      let acceptList = ["docx", "doc"]
      // 根据文件名获取文件的后缀名
      let fileType = file.name.split('.').pop().toLowerCase()
      // 判断文件格式是否符合要求
      if (acceptList.indexOf(fileType) === -1) {
        this.$message.error('只能上传 docx/doc 格式的文件');
        return false
      }
      // 判断文件大小是否符合要求
      // if (file.size / 1024 / 1024 > 1) {
      //   this.$message.error('上传文件大小不能超过 1M');
      //   return false
      // }
      var account_id = this.$route.query.account_id;

      if (account_id == "" || account_id == undefined) {
        this.$alert('参数[account_Id]不能为空', '系统提示', {
          confirmButtonText: '确定',
          type: 'error'
        });
        return false
      }
      this.uploadData.AccountId = account_id;
      this.uploadData.Content = "";
    },
    uploadSuccess(response, file, fileList) {
      if (response.is_success == true) {
        this.$message.success("上传成功");
        this.tempContent = response.data;

        this.checkArticl();
      } else {
        this.$message.error(file.name + '上传失败!');
      }
      this.delShowFile(file, fileList);
    },
    // 把上传失败的从list中删除
    delShowFile(file, fileList) {
      let index = fileList.findIndex(item => {
        return item.name === file.name;
      });
      if (index !== -1) {
        fileList.splice(index, 1);
      }
    },
    //校验文本按钮
    async checkArticl() {
      var Content = this.tempContent;

      this.clearData();

      this.tempContent = Content;
      this.tempContent = this.tempContent.replace(/&nbsp;/gi, "")
      this.tempContent = this.tempContent.replace(/\s+/g, "");
      this.tempContent = this.tempContent.replace(/<[^>]+>/g, '')
      var account_id = this.$route.query.account_id;
      var subaccount_id = this.$route.query.subaccount_id;

      if (account_id == "" || account_id == undefined) {
        this.$alert('参数[account_Id]不能为空', '系统提示', {
          confirmButtonText: '确定',
          type: 'error'
        });
        return;
      }
      // if (this.tempContent == '' || this.tempContent.length < 10 || this.tempContent.length > 5000) {
      //   this.$alert('请正确输入10-5000字符文字', '系统提示', {
      //     confirmButtonText: '确定',
      //     type: 'error'
      //   });
      //   return;
      // }

      if (this.tempContent == '') {
        this.$alert('请输入相关待审核内容', '系统提示', {
          confirmButtonText: '确定',
          type: 'error'
        });
        return;
      }
      this.params.AccountId = account_id;
      this.params.SubAccountId = subaccount_id;
      this.params.Content = this.tempContent;

      this.loading = this.$loading({
        lock: true,
        text: "处理请求中...",
        spinner: 'el-icon-phone-outline',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      verifyTextByIJiaoDui(this.params).then((data) => {
        if (data.is_success == true) {
          this.enderContent = data.Result.SourceText;
          this.listData = data.Result.CheckItems;
          this.$store.commit("saveCheckArticle", this.enderContent);
          this.tempContent = this.$store.state.checkArticle;

          this.$store.commit("saveCheckList", this.listData);
          this.tempListData = this.$store.state.checkList;
          if (this.listData == '' || this.listData == 'undifind' ||  this.listData == null || this.listData.length == 0) {
            this.$alert('暂无错误', '系统提示', {
              confirmButtonText: '确定',
              type: 'warning'
            });
          }
          this.DealData();
          this.countNum();
        } else {
          this.$message({
            message: data.message,
            type: 'error'
          })
        }
        this.loading.close();
      })
    },
    //清空
    clearData() {
      this.tempListData = [];
      this.listData = [];
      this.enderContent = "";
      this.tempContent = '';
      this.countNum();
    },
    //处理数据
    DealData() {
      this.tempContent = this.$store.state.checkArticle;

      for (var i = this.listData.length - 1; i >= 0; i--) {
        var sourceKeyWordTextColor = this.getDataColor(this.listData[i].level);
        var sourceKeyWordText =
          '<span style="border-bottom:2px solid ' + sourceKeyWordTextColor + ';">' +
          this.listData[i].sourceKeyWord +
          '</span>';
        this.tempContent = replaceSubstring(
          this.tempContent,
          this.listData[i].startPos,
          this.listData[i].sourceKeyWord,
          sourceKeyWordText
        );

        this.listData[i].sourceKeyWordText = sourceKeyWordText;

        var replaceKeywordText =
          '<span style="color:#000;">' +
          this.listData[i].replaceKeyword +
          '</span>';
        this.listData[i].replaceKeywordText = replaceKeywordText;

        var sourceKeyWordText_hulv =
          '<span style="color:#000;">' +
          this.listData[i].sourceKeyWord +
          '</span>';
        this.listData[i].sourceKeyWordText_hulv = sourceKeyWordText_hulv;

        this.listData[i].isDeal = 0;
        this.listData[i].caozuo = 0; //0为未处理 1为替换 2为忽略 3为删除
      }

      this.tempListData = this.listData;
    },
    //计算最右侧总数
    countNum() {
      //全部数据统计
      var allDataList = this.listData.filter((item, index, arr) => {
        return item.isDeal == 0;
      });
      //leve==1为一般 2为严重
      //修改数据统计
      var changeData = this.listData.filter((item, index, arr) => {
        return item.isDeal == 1;
      });
      this.rightSpan.forEach(function (item, index, arr) {
        if (item.id == "11") {
          item.countNum = allDataList.length;
        }

        if (item.id == "22") {
          item.countNum = changeData.length;
        }
      });
    },
    //根据level只获取颜色，其它啥也不干
    getDataColor(level) {
      if (level == 1) {//一般
        return "#FFB800";
      } else if (level == 2) {//严重
        return "#FF5722";
      }

      return "#5FB878";//默认颜色为轻微
    },
    //只根据level标注颜色，其它啥也不干
    getColorTextByLevel(level, content, isErrorWord = false) {
      var textColor = this.getDataColor(level);
      if (isErrorWord) {
        var levelWord = "(轻微)";
        if (level == 1) {
          levelWord = "(一般)";
        } else if (level == 2) {
          levelWord = "(严重)";
        }
        return '<span style="color: ' + textColor + ';font-weight: bold;">' + content + '&nbsp;&nbsp;' + levelWord + '</span>';
      }
      return '<span style="color: ' + textColor + ';">' + content + '</span>';
    },
    addBgColor(startPos) {
      var obj = this.findById(this.listData, startPos);

      for (let item of this.listData) {
        var sourceKeyWordTextColor = this.getDataColor(item.level);
        if (item.startPos == obj.startPos) {
          var sourceKeyWordText =
            '<span style="border-bottom:2px solid ' + sourceKeyWordTextColor + ';background-color: ' + sourceKeyWordTextColor + ';">' +
            item.sourceKeyWord +
            '</span>';
          this.tempContent = this.tempContent.replace(
            obj.sourceKeyWordText,
            sourceKeyWordText
          );
          item.sourceKeyWordText = sourceKeyWordText;
        } else {
          var sourceKeyWordText =
            '<span style="border-bottom:2px solid ' + sourceKeyWordTextColor + ';">' +
            item.sourceKeyWord +
            '</span>';
          this.tempContent = this.tempContent.replace(
            item.sourceKeyWordText,
            sourceKeyWordText
          );
          item.sourceKeyWordText = sourceKeyWordText;
        }
      }
      this.tempListData = this.listData;

      this.currentListData(this.currentRightSpan);
    },
    //点击替换
    replaceWord(startPos) {
      var obj = this.findById(this.listData, startPos);

      if (obj == undefined) {
        return;
      }

      this.tempContent = this.tempContent.replace(
        obj.sourceKeyWordText,
        obj.replaceKeywordText
      );

      for (var i = 0; i < this.listData.length; i++) {
        if (this.listData[i].startPos == obj.startPos) {
          this.listData[i].isDeal = 1;
          this.listData[i].caozuo = 1;
        }
      }
      this.countNum();

      this.tempListData = this.listData.filter((item, index, arr) => {
        return item.isDeal == 0;
      });
    },
    //点击忽略
    ignoreWord(startPos) {
      var obj = this.findById(this.listData, startPos);
      if (obj == undefined) {
        return;
      }
      this.tempContent = this.tempContent.replace(
        obj.sourceKeyWordText,
        obj.sourceKeyWordText_hulv
      );

      for (var i = 0; i < this.listData.length; i++) {
        if (this.listData[i].startPos == obj.startPos) {
          this.listData[i].isDeal = 1;
          this.listData[i].caozuo = 2;
        }
      }
      this.countNum();

      this.tempListData = this.listData.filter((item, index, arr) => {
        return item.isDeal == 0;
      });
    },
    //点击撤销
    revokeWord(startPos) {
      var obj = this.findById(this.listData, startPos);
      if (obj == undefined) {
        return;
      }
      if (obj.caozuo == 1 && obj.isDeal == 1) {
        //替换
        this.tempContent = this.tempContent.replace(
          obj.replaceKeywordText,
          obj.sourceKeyWordText
        );

        for (var i = 0; i < this.listData.length; i++) {
          if (this.listData[i].startPos == obj.startPos) {
            this.listData[i].isDeal = 0;
            this.listData[i].caozuo = 0;
          }
        }
      } else if (obj.caozuo == 2 && obj.isDeal == 1) {
        //忽略
        this.tempContent = this.tempContent.replace(
          obj.sourceKeyWordText_hulv,
          obj.sourceKeyWordText
        );

        for (var i = 0; i < this.listData.length; i++) {
          if (this.listData[i].startPos == obj.startPos) {
            this.listData[i].isDeal = 0;
            this.listData[i].caozuo = 0;
          }
        }
      }
      this.countNum();
      this.tempListData = this.listData.filter((item, index, arr) => {
        return item.isDeal == 1;
      });
    },
    rightSpanClick(index) {
      this.currentRightSpan = index;
      this.currentListData(index);
    },
    currentListData(rsId = "11") {
      //需要过滤一下数据是否处理 isdeal
      if (rsId == "11") {
        this.tempListData = this.listData.filter((item, index, arr) => {
          return item.isDeal == 0;
        });
      }

      if (rsId == "22") {
        this.tempListData = this.listData.filter((item, index, arr) => {
          return item.isDeal == 1;
        });
      }
    },
    findById(array, startPos) {
      // 使用 Array.prototype.find() 方法查找特定对象
      return array.find(function (element) {
        return element.startPos === startPos;
      });
    },
  },
};
</script>

<style scoped>
.container {
  display: flex;
  width: 100%;
  height: 100%;
}
.left {
  width: 70%;
  height: 100%;
}
.center {
  flex: 1;
}
.right {
  width: 5%;
  height: 99%;
  border-left: 1px solid #eda91b;
  /*border-radius: 5px;*/
  margin: 8px 10px;
}
.head {
  position: absolute;
  width: 100%;
  height: 100%;
}
.card {
  display: block;
  margin: 15px;
  box-shadow: 2px 2px 4px -1px rgb(0 0 0 / 5%);
  border-radius: 4px;
  border: 2px solid #efefef;
  cursor: pointer;
  border-left: 3px solid #eda91b;
  background-color: #ffffff;
  width: 95%;
}
.card td{
  line-height: 150%;
}

.right div:hover {
  background-color: #f2fafd;
  border-radius: 10px;
}
.changeBk {
  background-color: #e5f5fc;
}
.top {
  position: relative;
  width: 100%;
  height: 50%;
  text-align: center;
  font-size: 30px;
  line-height: 96px;
}
.circular {
  position: absolute;
  width: 15px;
  height: 15px;
  top: 15px;
  right: 15px;

  /* background-color: #ED601B; */
  border-radius: 50%;

  /* float: right; */
}
.body {
  margin-top: 10px;
  text-align: center;
}
.btnClass {
  margin-top: 1.5%;
  display: flex;
  justify-content: space-around;
}

.ql-editor {
  padding: 0 !important;
  margin: 0 !important;
}

.card:hover {
  background-color: #f6f6f6;
}
.ql-container {
  font-size: 30px;
}
.addImg {
  background-image: url('../assets/nodata.png');
  background-repeat: no-repeat;
  background-position: center center;
}

#keywordTb {
  border-collapse: collapse;
  width: 100%;
  height: 97.5%;
  border: 1px solid #ddd;
  font-size: 14px;
}

#keywordTb tr {
  height: 30%;
}
#keywordTb td {
  border: 1px solid #ddd;
  padding: 5px;
  text-align: left;
}
#keywordTb tr:nth-child(even) {
  background-color: #f2f2f2;
}
#keywordTb tr:hover {
  background-color: #ddd;
}

#keywordTb tr:nth-child(2) {
  border-radius: 10px;
}
.caozuo_AllDiv {
  width: 20%;
  float: right;
  margin-right: 16px;
  height: 100%;
  display: flex;
  justify-content: space-between;
}
.caozuo_changeDiv {
  width: 20%;
  float: right;
  margin-right: 16px;
  height: 100%;
  display: flex;
  justify-content: flex-end;
}
.caozuoTitle {
  text-decoration: none;
  margin-top: 8px;
  color: #2fb2e5;
}
</style>